import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { ForumLink } from '@/models/ForumLink';
import ParticipationService from '@/services/ParticipationService';
import BCXParticipateLinks from '@/components/navigation/panels/BCXParticipateLinks.vue';
import BCXTextArea from '@/components/molecules/forms/BCXTextArea.vue';
import BCXAvatar from '@/components/molecules/BCXAvatar.vue';
import X from '@/components/svg-components/X.vue';
import Chevron from '@/components/svg-components/Chevron.vue';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import BCXSearchSelectNew from '@/components/molecules/BCXSearchSelect.vue';
import useResponsiveness from '@/mixins/useResponsiveness';
import useUser from '@/mixins/useUser';
import { i18nToItemList } from '@/utils/selectItemTools';
import useI18n from '@/mixins/useI18n';
import { templateRef, useDebounceFn, whenever } from '@vueuse/core';
import { createVuexHelpers } from 'vue2-helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXParticipate',
  setup(__props) {

const { tUserFallback } = useUser('self');
const tUser = tUserFallback;

const category = ref('');
const text = ref('');
const title = ref('');
const linkList = ref<ForumLink[]>([]);
const isTextAreaBig = ref(false);
const isSubmitted = ref(false);
const bigAreaHeight = ref(125);
const maxLength = 5000;
const el = templateRef<HTMLElement>('el');

const { t } = useI18n();
const { isMobileWidth } = useResponsiveness();
const { user } = useUser('self');

const categoryItems = i18nToItemList('participate.categories');
const inputEnabled = computed(() => category.value !== '');
const canSend = computed(() => !!title.value.trim().length
  && !!text.value.trim().length
  && !!category.value
  && !isSubmitted.value);
const canSearch = computed(() => !!title.value.trim().length && !!category.value);

const { useMutations } = createVuexHelpers();
const { setIsParticipateVisible }: any = useMutations('page', ['setIsParticipateVisible']);

const search = async () => {
  if (canSearch.value) {
    const links = await ParticipationService.getMatchingTopics(title.value, category.value);
    if (Array.isArray(links)) {
      if (links?.length > 10) links.length = 10;
      linkList.value = links;
    } else {
      linkList.value = [];
    }
  }
};

const debouncedSearch = useDebounceFn(search, 500);

text.value = `${t('participate.default_text')}`;

const setEnlargedHeight = () => {
  const elements = Array.from(el.value.querySelectorAll('.c-hidden-when-big'));
  let height = 0;
  elements.forEach((element:HTMLElement) => {
    height += element.getBoundingClientRect().height;
  });
  bigAreaHeight.value = height - 32; // Substract Text row bottom padding
};

const resetForm = () => {
  isSubmitted.value = false;
  title.value = '';
  category.value = '';
  text.value = '';
  isTextAreaBig.value = false;
  linkList.value = [];
};

const closePanel = () => {
  setIsParticipateVisible(false);
};

const closeDesktopPanel = () => {
  if (!isMobileWidth.value) {
    closePanel();
  }
};

whenever(isTextAreaBig, () => {
  setEnlargedHeight();
});

watch([title, category], () => debouncedSearch());

const submit = async () => {
  await ParticipationService.addParticipationTopic(title.value, category.value, text.value);
  isSubmitted.value = true;
  setTimeout(() => {
    closePanel();
    resetForm();
  }, 2000);
};


return { __sfc: true,tUserFallback, tUser, category, text, title, linkList, isTextAreaBig, isSubmitted, bigAreaHeight, maxLength, el, t, isMobileWidth, user, categoryItems, inputEnabled, canSend, canSearch, useMutations, setIsParticipateVisible, search, debouncedSearch, setEnlargedHeight, resetForm, closePanel, closeDesktopPanel, submit, BCXParticipateLinks, BCXTextArea, BCXAvatar, X, Chevron, BCXMarkdown, BCXSearchSelectNew }
}

})